import { API } from "../../../axios";
import swal from "sweetalert2";
import { handleRegistrationError } from "@/plugins/store/errorHandlerSwal";

// Laufende Katalog-Anfrage, damit mehrere Ansichten gleichzeitig nur einmal laden
let disciplinesRequest = null;

const actions = {
  async getuwelcomeText({ commit }) {

    await API.post("/getText",
      {
        text_search: "uwelcome"
      })
      .then((response) => {
        commit("get_UWelcomeText", response.data.Text);
        // resolve(response)
      })
      .catch(error => {
        console.log(error);
      });
  },
  async getTextNewUser({ commit }) {

    await API.post("/getText",
      {
        text_search: "uNeu"
      })
      .then((response) => {
        commit("get_TextNewUser", response.data.Text);
        // resolve(response)
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getTextueberlassung({ commit }) {

    await API.post("/getText",
      {
        text_search: "ueberlassung"
      })
      .then((response) => {
        commit("get_TextUeberlassung", response.data.Text);
        // resolve(response)
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getEduData({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/education")
      .then((resp) => {
        const allEdu = resp.data.allEdu;
        const myEdu = resp.data.eduDaten;
        commit("get_Education", { allEdu, myEdu });

      })
      .catch(error => {
        console.log(error);
      });
  },

  async getWeapons({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/weapons")
      .then((resp) => {
        const data = resp.data;
        commit("get_Weapons", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getClubs({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/getmyClubs")
      .then((resp) => {
        const data = resp.data;
        commit("get_MyClubs", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getMyShootingbook({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/getmyshootingbook")
      .then((resp) => {
        const data = resp.data;
        commit("get_MyShootingbook", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async send_ShootingBookRecord_to_confirmation({ dispatch, rootState, commit }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/shootingbook/submit_confirmation", Data)
      .then(() => {
        dispatch("getMyShootingbook");
        commit("SET_SHOOTINGBOOK_LOADER", false);
      })
      .catch(error => {
        swal.fire("Bestätigung einreichen", "Es ist etwas schiefgelaufen beim einreichen", "warning");
        console.log(error);
        commit("SET_SHOOTINGBOOK_LOADER", false);
      });

  },

  async getOpenShootingBookEntry({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/recordShootingTime/getopenEntrys")
      .then((resp) => {
        const data = resp.data;
        commit("get_OpenShootingBookEntry", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getOpenShootingBookData({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/recordShootingTime")
      .then((resp) => {
        const data = resp.data;
        commit("get_OpenShootingBookData", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async getDisziWeapon({ commit, rootState }, waffenID) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/recordShootingTime/getDisziWaffe", {
      params: {
        waffenID
      }
    })
      .then((resp) => {
        const data = resp.data;
        commit("get_Diszi_Weapons", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  // Disziplinen einer beliebigen Waffe, auch einer Poolwaffe (eigene bringen sie in Weapons schon mit).
  // Gibt die Liste zurück statt sie im State abzulegen – Fehler behandelt der Aufrufer.
  async fetchWeaponDisciplines({ rootState }, waffenID) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    const { data } = await API.get("/user/weapons/Discipline/show", { params: { waffenID } });
    return Array.isArray(data) ? data : [];
  },

  // Disziplinkatalog nur laden, wenn er im Speicher fehlt (wird nicht in localStorage abgelegt, siehe store/index.js)
  ensureDisciplines({ state, dispatch }) {
    if (state.Discipline && state.Discipline.length) return Promise.resolve();
    if (!disciplinesRequest) {
      disciplinesRequest = dispatch("getAllDiszi").finally(() => {
        disciplinesRequest = null;
      });
    }
    return disciplinesRequest;
  },

  async getAllDiszi({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/weapons/Discipline")
      .then((resp) => {
        const data = resp.data;
        commit("get_Diszi_All", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  // async getDisciplineSingelWeapon({commit, rootState}, waffenID){
  //     API.defaults.headers.common['Authorization'] = `Bearer ${rootState.UserAuth.token}`
  //     await API.get('/user/weapons/Discipline/show', {
  //         params: {
  //             waffenID
  //         }
  //     })
  //         .then((resp) => {
  //             const data = resp.data
  //             commit('get_Diszi_Single_Weapons', data)
  //         })
  //         .catch(error => {
  //             console.log(error);
  //         });
  // },

  async getShootingRangeFreeplaces({ commit, rootState }, SRID) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    commit("SET_POPUP_RECORDSHOOTINGTIME_FREEPLACES_LOADER", true);
    await API.get("/user/shootinrange/getfreeplaces", {
      params: {
        shootingrange_id: SRID
      }
    })
      .then((resp) => {
        const data = resp.data;
        commit("GET_SHOOTINGRANGEFREEPLACES", data);
        commit("SET_POPUP_RECORDSHOOTINGTIME_FREEPLACES_LOADER", false);
      })
      .catch(error => {
        console.log(error);
        commit("SET_POPUP_RECORDSHOOTINGTIME_FREEPLACES_LOADER", false);
      });
  },

  async setDisciplinWeapon({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/weapons/Discipline/Discipline_add", Data)
      .then(() => {
        // dispatch('getDisciplineSingelWeapon', Data.waffenID);
        dispatch("getWeapons");
        dispatch("UserApp/getDashboard", null, { root: true });
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },

  async delDisciplinWeapon({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/weapons/Discipline/Discipline_del", Data)
      .then(() => {
        // dispatch('getDisciplineSingelWeapon', Data.waffenID);
        dispatch("getWeapons");
        dispatch("UserApp/getDashboard", null, { root: true });
      })
      .catch(error => {
        console.log(error);
        swal.fire("Waffe löschen", "Es ist etwas schiefgelaufen beim löschen", "warning");
      });

  },

  async setNewShootingBookRecord({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/recordShootingTime", Data)
      .then(() => {
        dispatch("getOpenShootingBookEntry");
        dispatch("UserApp/getDashboard", null, { root: true });
        dispatch("UserApp/getMyShootingbook", null, { root: true });
        swal.fire("Schiessbuch", "Dein Eintrag wurde erfolgreich erfasst", "success");
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });

  },

  async setNewExternalShootingBookRecord({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/recordShootingTime_external", Data)
      .then(() => {
        // dispatch('getOpenShootingBookEntry');
        dispatch("UserApp/getDashboard", null, { root: true });
        dispatch("UserApp/getMyShootingbook", null, { root: true });
        swal.fire("Schiessbuch", "Dein Eintrag wurde erfolgreich erfasst", "success");
      })
      .catch(error => {
        // 403 kommt nur von der Pool-Prüfung und liefert nur { message } – das zeigt handleRegistrationError nicht an
        if (error.response && error.response.status === 403) {
          swal.fire("Waffenpool", "Du darfst diese Pool-Waffe nicht nutzen. Die Waffe ist inaktiv, oder der Waffenpool ist im Verein nicht freigeschaltet.", "warning");
        } else {
          handleRegistrationError(error);
        }
        throw error;
      });

  },

  async sign_Shootingbook_entry({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/shootingbook/sign", Data)
      .then(() => {
        dispatch("getMyShootingbook");
      })
      .catch(error => {
        const message = error.response.data.message;
        swal.fire("Signieren", message, "warning");
      });

  },

  async get_Shootingbook_sign({ commit, rootState }, Data) {
    commit("CLEAR_SHOOTINGBOOK_SIGNATURE");
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/shootingbook/show_sign", {
      params: Data
    })
      .then((resp) => {
        const data = resp.data;
        commit("GET_SHOOTINGBOOK_SIGNATURE", data);
        commit("SET_SHOOTINGBOOK_LOADER", false);
      })
      .catch(error => {
        const message = error.response.data.message;
        commit("SET_SHOOTINGBOOK_SIGN_ERROR", true);
        commit("SET_SHOOTINGBOOK_LOADER", false);
        swal.fire("Signieren", message, "warning");
      });
  },

  async get_WaffGCompliance({ commit, rootState }) {
    commit("SET_SHOOTINGBOOK_LOADER", true);
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/analytics/waffg-compliance")
      .then(resp => {
        const data = resp.data;
        commit("GET_WaffGCompliance", data);
        commit("SET_SHOOTINGBOOK_LOADER", false);
      })
      .catch(error => {
        commit("SET_SHOOTINGBOOK_LOADER", false);
        handleRegistrationError(error);
      });
  },

  async updateNewShootingBookRecord({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/recordShootingTime/update", Data)
      .then(() => {
        dispatch("getOpenShootingBookEntry");
        dispatch("UserApp/getDashboard", null, { root: true });
        dispatch("UserApp/getMyShootingbook", null, { root: true });
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },

  async delShootingbookEntry({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/recordShootingTime/delete", Data)
      .then(() => {
        dispatch("getOpenShootingBookEntry");
        dispatch("UserApp/getDashboard", null, { root: true });
        dispatch("UserApp/getMyShootingbook", null, { root: true });
        swal.fire("Eintrag gelöscht", "Der Eintrag wurde erfolgreich gelöscht", "success");
      })
      .catch(error => {
        swal.fire("Eintrag beenden", "Es ist etwas schiefgelaufen beim beenden", "warning");
        console.log(error);
      });
  },

  async setNewWeapon({ dispatch, rootState }, Data) {
    API.defaults.headers.common[
      "Authorization"
      ] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/weapons/weapon_store", Data)
      .then(() => {
        dispatch("getWeapons");
        dispatch("UserApp/getDashboard", null, { root: true });
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });

  },

  async delWeapon({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/weapons/weapon_delete", {
      params: Data
    })
      .then((resp) => {
        dispatch("getWeapons");
        dispatch("UserApp/getDashboard", null, { root: true });
        swal.fire("Waffe löschen", resp.data, "success");
      })
      .catch(error => {
        // 422 = Regel aus dem WeaponObserver (z. B. Grundwaffe mit Wechselsystemen) – Klartext zeigen
        if (error.response && error.response.status === 422) {
          handleRegistrationError(error);
        } else {
          console.log(error);
          swal.fire("Waffe löschen", "Es ist etwas schiefgelaufen beim löschen", "warning");
        }
      });

  },

  async setMyClub({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/addClub", Data)
      .then(() => {
        dispatch("getClubs");
        dispatch("UserAuth/getUserProfilData", null, { root: true });
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },

  async delMyClub({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/delClub", Data)
      .then(() => {
        dispatch("getClubs");
        dispatch("UserAuth/getUserProfilData", null, { root: true });
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },

  async setEducation({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/education/education_add", Data)
      .then(() => {
        dispatch("getEduData");
      })
      .catch(error => {
        console.log(error);
      });

  },

  async delEducation({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/education/education_del", Data)
      .then(() => {
        dispatch("getEduData");
      })
      .catch(error => {
        console.log(error);
      });

  },
  async getDashboard({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/dashboard")
      .then((resp) => {
        const data = resp.data;
        commit("GET_DASHBOARD", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getChartsData({ commit, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/analytics/weapon/Chart", {
      params: Data
    })
      .then((resp) => {
        const data = resp.data;
        commit("GET_CHARTSDATA", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async getShootingbookCountData({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/analytics/shootingbook/getShootingbookCount")
      .then((resp) => {
        const data = resp.data;
        commit("GET_SHOOTINGBOOK_COUNT", data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async getSelectedShootingRanges({ commit, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.get("/user/recordShootingTime/getShootingRange", {
      params: Data
    })
      .then((resp) => {
        const data = resp.data.ClubRanges;
        commit("SET_SELECTED_SHOOTINGRANGES", data);
      })
      .catch(error => {
        console.log(error);
        swal.fire("Schiessstände", "Fehler in der Ermittlung der Schiessstände", "warning");
      });
  },

  set_SelectedShootingRanges_to_Default({ commit }) {
    commit("SET_SELECTED_SHOOTINGRANGES", []);
  },

  set_recordshootingTime_Freeplaces_PopUp({ commit }, Data) {
    commit("SET_POPUP_RECORDSHOOTINGTIME_FREEPLACES", Data);
  },

  async fetchPoolWeapons({ commit, state, rootState }, filters = {}) {
    const token = `Bearer ${rootState.UserAuth.token}`;
    API.defaults.headers.common["Authorization"] = token;

    // Prüfe ob der Verein einen Pool hat, falls eine ID übergeben wurde
    if (filters.verein_id) {
      const clubs = state.Clubs;
      if (clubs && clubs.meineVereine) {
        const selectedClub = clubs.meineVereine.find(v => v.id === filters.verein_id);
        if (selectedClub && selectedClub.has_weapon_pool === false) {
          commit("SET_WEAPON_POOL", []);
          return;
        }
      }
    } else {
      // Wenn keine ID übergeben wurde, prüfen wir den Default-Verein
      const clubs = state.Clubs;
      if (clubs && clubs.defVerein && Array.isArray(clubs.defVerein) && clubs.defVerein.length > 0) {
        const defId = clubs.defVerein[0].defaultVerein;
        const defaultClub = clubs.meineVereine ? clubs.meineVereine.find(v => v.id === defId) : null;
        if (defaultClub && defaultClub.has_weapon_pool === false) {
          commit("SET_WEAPON_POOL", []);
          return;
        }
      }
    }

    try {
      const response = await API.get("/user/weaponpool", { params: filters });
      commit("SET_WEAPON_POOL", response.data);
    } catch (error) {
      commit("SET_WEAPON_POOL", []);
      if (!error.response || error.response.status !== 403) {
        swal.fire("Fehler", "Pool-Waffen konnten nicht geladen werden", "error");
      }
    }
  },

  // Eigener State für die externe Maske: WeaponPool wird von der internen Maske mit dem Pool
  // des dort gewählten Vereins gefüllt, extern ist aber nur der Hauptverein erlaubt.
  async fetchPoolWeaponsHauptverein({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    try {
      // ohne verein_id nimmt das Backend den Hauptverein
      const response = await API.get("/user/weaponpool");
      commit("SET_WEAPON_POOL_HAUPTVEREIN", response.data);
    } catch (error) {
      commit("SET_WEAPON_POOL_HAUPTVEREIN", []);
      if (!error.response || error.response.status !== 403) {
        swal.fire("Fehler", "Pool-Waffen konnten nicht geladen werden", "error");
      }
    }
  },

  async fetchMyPoolContributions({ commit, rootState }) {
    const token = `Bearer ${rootState.UserAuth.token}`;
    API.defaults.headers.common["Authorization"] = token;

    const response = await API.get("/user/weaponpool/mine");
    commit("SET_MY_POOL_CONTRIBUTIONS", response.data);
  },

  async addWeaponToPool({ dispatch, rootState }, { weapon_id, verein_id, notes }) {
    const token = `Bearer ${rootState.UserAuth.token}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/user/weaponpool/add", { weapon_id, verein_id, notes })
      .then((resp) => {
        dispatch("fetchMyPoolContributions");
        dispatch('getWeapons');
        swal.fire(
          "Waffenpool",
          resp.data.message || "Waffe erfolgreich hinzugefügt",
          "success"
        );
      })
      .catch(error => {
        swal.fire("Fehler", error.response?.data?.error || "Fehler beim Hinzufügen", "error");
      });
  },

  async removeWeaponFromPool({ dispatch, rootState }, weapon_pool_id) {
    const token = `Bearer ${rootState.UserAuth.token}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/user/weaponpool/remove", { weapon_pool_id }).then(() => {
      dispatch("fetchMyPoolContributions");
      dispatch('getWeapons');
      swal.fire("Erfolg", "Waffe aus Pool entfernt", "success");
    });
  },

  async updateWeaponPoolNotes({ dispatch, rootState }, { weapon_pool_id, notes }) {
    const token = `Bearer ${rootState.UserAuth.token}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/user/weaponpool/update", { weapon_pool_id, notes })
      .then(() => {
        dispatch("fetchMyPoolContributions");
        dispatch('getWeapons');
        swal.fire("Erfolg", "Hinweise aktualisiert", "success");
      });
  },

  async getSchiessleiterToday({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    const resp = await API.get("/user/schiessleiter/today");
    commit("SET_SCHIESSLEITER_TODAY", resp.data);
  },

  async schiessleiterEndEntry({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    await API.post("/user/schiessleiter/today/end", Data)
      .then(() => {
        dispatch("getSchiessleiterToday");
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },

  // Arbeitsstunden - User Actions
  async getArbeitsstundenFunctions({ commit, rootState }, params) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    return API.get("user/arbeitsstunden/funktionen", { params })
      .then(resp => {
        commit("SET_ARBEITSSTUNDEN_FUNCTIONS", resp.data);
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getUserArbeitseinsaetze({ commit, rootState, rootGetters }, params) {
    if (rootGetters["UserAuth/isLoggedIn"]) {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    } else if (rootGetters["ClubAuth/isLoggedIn"]) {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    }
    return API.get("user/arbeitseinsaetze", { params })
      .then(resp => {
        commit("SET_ARBEITSEINSAETZE", resp.data);
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async toggleUserArbeitseinsatzAnmelden({ dispatch, rootState }, { id, data }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    return API.post(`user/arbeitseinsaetze/${id}/anmelden`, data)
      .then(() => {
        dispatch("getUserArbeitseinsaetze");
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getUserWorkingHours({ commit, rootState }, params) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    return API.get("user/arbeitsstunden/eintraege", { params })
      .then(resp => {
        commit("SET_WORKING_HOURS", resp.data);
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async send_WorkingHoursRecord_to_confirmation({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    return API.post("/user/shootingbook/submit_confirmation", Data)
      .then(() => {
        dispatch("getUserWorkingHours");
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },


  async fetchBeduerfnisOptions({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;

    try {
      const response = await API.get("/user/weapons/beduerfnis-options");
      commit("SET_BEDUERFNIS_OPTIONS", response.data);
    } catch (error) {
      console.error("Fehler beim Laden der Bedürfnis-Optionen:", error);
      swal.fire("Fehler", "Bedürfnis-Optionen konnten nicht geladen werden", "error");
    }
  },

  // Disziplinblatt (Beta) – Ergebnisse gehören nur zur Ansicht, deshalb kein State
  async searchDisciplines({ rootState }, { q, verband, group, dist }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    const response = await API.get("/user/disciplines", { params: { q, verband, group, dist } });
    return response.data;
  },

  async getDisciplineSheet({ rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
    const response = await API.get(`/user/disciplines/${id}/sheet`);
    return response.data;
  },

  handleError(_, error) {
    handleRegistrationError(error);
  }
};

export default actions;
